<template>
  <!-- data list is a key value pair list. the UI should be responsive:
   small screen: label on top of value
   bigger screen: label on left of value. the start of values should be aligned
   
   This is a crude implementation, and seems to work well enough. 
   Longer labels/values may require additional tweaks.
   v-container was not used, because the columns get quite wide on bigger screens.
   For example, col-3 & col-9 would be nice on small&medium, but on large 
   the gap between label and value is too wide.
  -->
  <dl class="text-left">
    <template
      v-for="item in listData"
      :key="item.label"
    >
      <dt class="data-title" :class="{'text-medium-emphasis': styleLabelAsLabel}">
        {{ item.label }}
      </dt>
      <dd class="data-value mb-4 mb-sm-0">
        <template v-if="Array.isArray(item.value)">
          <span
            v-for="(val, index) in item.value"
            :key="index"
            class="d-block"
          >
            {{ val }}
          </span>
        </template>
        <template v-else>
          {{ item.value }}
        </template>
      </dd>
    </template>
  </dl>
</template>
<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
const { t: $t } = useI18n();
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = defineProps<{
  listData: { label: string; value?: string | string[] }[];
  styleLabelAsLabel?: boolean; // if true, label is styled as label, otherwise as regular text
}>();
</script>
<style scoped lang="scss">
@use '@/styles/settings' as settings;

dl {
  display: grid;
  grid-template-columns: 1fr;
  column-gap: 1rem;
}

@media (min-width: 600px) {
  dl {
    grid-template-columns: auto 1fr;
  }
}
</style>